import React, { useEffect, useState } from 'react';
import axios from 'axios';
import EditPlotModal from './EditPlotModal';
import './ProjectPlotViewer.css';

const ProjectPlotViewer = () => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [plots, setPlots] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPlot, setSelectedPlot] = useState(null);
  const [plotSearch, setPlotSearch] = useState("");

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/projects`)
      .then(res => setProjects(res.data.projects))
      .catch(err => console.error('Failed to fetch projects:', err));
  }, []);

  const handleSearch = () => {
    if (!selectedProject) return;
    axios.get(`${process.env.REACT_APP_API_URL}/api/plots/${selectedProject}`)
      .then(res => setPlots(res.data.plots))
      .catch(err => console.error('Failed to fetch plots:', err));
  };

  const openEditModal = (plot) => {
    setSelectedPlot(plot);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedPlot(null);
  };

  const updatePlotInList = (updatedPlot) => {
    setPlots(plots.map(p => p.id === updatedPlot.id ? updatedPlot : p));
  };

  // ✅ filter plots using the search box
  const filteredPlots = plots.filter(p =>
    p.plot_number.toString().includes(plotSearch.toLowerCase()) ||
    p.svg_id.toLowerCase().includes(plotSearch.toLowerCase()) ||
    p.status.toLowerCase().includes(plotSearch.toLowerCase())
  );


  return (
    <div className="project-viewer-container">
      <h2>Select Project to View Plots</h2>
      <select value={selectedProject} onChange={(e) => setSelectedProject(e.target.value)}>
        <option value="">-- Choose a Project --</option>
        {projects.map((proj) => (
          <option key={proj.id} value={proj.id}>{proj.name}</option>
        ))}
      </select>
      <button onClick={handleSearch}>Search</button>

      {plots.length > 0 && (
       <> 
       <br/>
    <input
      type="text"
      placeholder="Search Plot No. / SVG ID / Status..."
      className="plot-search"
      value={plotSearch}
      onChange={(e) => setPlotSearch(e.target.value)}
    />       
        <table className="plots-table">
          <thead>
            <tr>
              <th>Plot No.</th>
              <th>SVG ID</th>
              <th>Status</th>
              <th>Price</th>
              <th>Size</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredPlots.map((plot) => (
              <tr key={plot.id}>
                <td>{plot.plot_number}</td>
                <td>{plot.svg_id}</td>
                <td>{plot.status}</td>
                <td>{plot.price}</td>
                <td>{plot.size}</td>
                <td><button onClick={() => openEditModal(plot)}>Edit</button></td>
              </tr>
            ))}
          </tbody>
        </table>
        </>
      )}

      {showModal && (
        <EditPlotModal
          plot={selectedPlot}
          onClose={handleModalClose}
          onUpdate={updatePlotInList}
        />
      )}
    </div>
  );
};

export default ProjectPlotViewer;
